<script setup="">
import { BellIcon, BookOpenCheckIcon, MilestoneIcon } from "lucide-vue-next";

import useNotification from "@/composables/notification";
import useSidebar from "@/composables/sidebar";
import { Link, usePage } from "@inertiajs/vue3";

const page = usePage();
const sidebar = useSidebar();
const notification = useNotification();

const navs = [
  {
    name: "가이드",
    icon: BookOpenCheckIcon,
    href: "https://charmed-eoraptor-f11.notion.site/100-13b3c08e3f8a8041913ad3be351bf37a",
    target: "_blank",
    current: "",
    enable: true
  },
  {
    name: "공지사항",
    icon: MilestoneIcon,
    href: route("notices.index"),
    current: route().current("notices.*"),
    new: page.props.has_new_notice,
    enable: true
  },
  {
    name: "알림",
    icon: BellIcon,
    href: route("notifications.index"),
    current: route().current("notifications.*"),
    count: notification.unreadCount,
    enable: true
  }
];
</script>

<template>
  <div class="flex-center xl:px-2">
    <ul class="xl:w-full">
      <template v-for="(nav, index) in navs">
        <li v-if="nav.enable" :key="index" class="mb-2">
          <a
            v-if="nav.target && nav.target === '_blank'"
            :class="[
              nav.current ? 'text-black dark:text-zinc-100' : 'text-500 hover:text-800 dark:hover:text-white',
              nav.class,
              { 'items-center justify-center': sidebar.isPrimaryMinimized.value, 'justify-between px-4': !sidebar.isPrimaryMinimized.value }
            ]"
            :href="nav.href"
            target="_blank"
            class="group relative flex rounded-lg py-2 text-base tracking-wide outline-none ring-0 transition-all focus:outline-0 dark:border-zinc-700"
          >
            <div class="flex items-center space-x-3">
              <span>
                <component
                  :is="nav.icon"
                  v-tippy="{ content: nav.name, placement: 'right' }"
                  class="minimized h-6 w-6 transition duration-300 focus:outline-none focus:ring-0 group-hover:scale-110"
                />
                <component :is="nav.icon" class="expanded h-6 w-6 transition duration-300 group-hover:scale-110" />
              </span>
              <span class="expanded whitespace-nowrap text-sm+ font-semibold" v-text="nav.name"></span>
            </div>
          </a>
          <Link
            v-else
            :class="[
              nav.current ? 'text-black dark:text-zinc-100' : 'text-500 hover:text-800 dark:hover:text-white',
              nav.class,
              { 'items-center justify-center': sidebar.isPrimaryMinimized.value, 'justify-between px-4': !sidebar.isPrimaryMinimized.value }
            ]"
            :href="nav.href"
            class="group relative flex rounded-lg py-2 text-base tracking-wide outline-none ring-0 transition-all focus:outline-0 dark:border-zinc-700"
          >
            <div class="flex items-center space-x-3">
              <span>
                <component
                  :is="nav.icon"
                  v-tippy="{ content: nav.name, placement: 'right' }"
                  class="minimized h-6 w-6 transition duration-300 focus:outline-none focus:ring-0 group-hover:scale-110"
                />
                <component :is="nav.icon" class="expanded h-6 w-6 transition duration-300 group-hover:scale-110" />
              </span>
              <span class="expanded whitespace-nowrap text-sm+ font-semibold" v-text="nav.name"></span>
            </div>
          </Link>
        </li>
      </template>
    </ul>
  </div>
</template>
